/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { ConvertDatesToStrings } from '@itk/typescript-utils'
import type { Model_AttributeGet } from '../models/Model_AttributeGet';
import type { Model_ProductTypeAttributesGet } from '../models/Model_ProductTypeAttributesGet';
import type { Model_ProductTypeAttributesPost } from '../models/Model_ProductTypeAttributesPost';
import type { Shared_AttributeOwnerEntityKinds } from '../models/Shared_AttributeOwnerEntityKinds';
import type { Shared_AttributeTypes } from '../models/Shared_AttributeTypes';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AttributeService {
    /**
     * @param attributeEntityKind
     * @param attributeType
     * @param attributeEntityFilterId
     * @returns Model_AttributeGet Success
     * @throws ApiError
     */
    public static getApiV1Attributes(
        attributeEntityKind?: ConvertDatesToStrings<Shared_AttributeOwnerEntityKinds>,
        attributeType?: ConvertDatesToStrings<Shared_AttributeTypes>,
        attributeEntityFilterId?: ConvertDatesToStrings<string>,
    ): CancelablePromise<Array<Model_AttributeGet>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/attributes',
            query: {
                'attributeEntityKind': attributeEntityKind,
                'attributeType': attributeType,
                'attributeEntityFilterId': attributeEntityFilterId,
            },
        });
    }
    /**
     * The attribute definitions each requested product type owns, plus any value the selected lines
     * agree on — no rule evaluation.
     * Serves the bulk product editor, which sets one value across many products of a type. An attribute
     * carries a value only where every selected line stores the same one, and carries ValuesDiffer where
     * they store more than one, so a blank field can say which of the two it is.
     * @param requestBody The product types to resolve definitions for, and the selected lines.
     * @returns Model_ProductTypeAttributesGet Success
     * @throws ApiError
     */
    public static postApiV1AttributesProductTypeAttributes(
        requestBody?: ConvertDatesToStrings<Model_ProductTypeAttributesPost>,
    ): CancelablePromise<Array<Model_ProductTypeAttributesGet>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/attributes/productTypeAttributes',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
